import { render } from "./case_study_slider.vue?vue&type=template&id=1df2f675"
import script from "./case_study_slider.vue?vue&type=script&lang=js"
export * from "./case_study_slider.vue?vue&type=script&lang=js"

import exportComponent from "/home/thedrago/public_html/NewSite2023/wp-content/themes/chop-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/case_study_slider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1df2f675"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1df2f675', __exports__)) {
    api.reload('1df2f675', __exports__)
  }
  
  module.hot.accept("./case_study_slider.vue?vue&type=template&id=1df2f675", () => {
    api.rerender('1df2f675', render)
  })

}


export default __exports__